import { useEffect, useState } from 'react'

const useMobileKeyboardOpen = defaultValue => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(defaultValue)
  const [keyboardHeight, setKeyboardHeight] = useState(null)

  useEffect(() => {
    const listener = () => {
      const newState = window.screen.availHeight > window.visualViewport.height
      if (isKeyboardOpen !== newState) {
        setIsKeyboardOpen(newState)
      }

      if (newState) {
        const keyboardHeight = window.innerHeight - window.visualViewport.height
        setKeyboardHeight(keyboardHeight)
      } else {
        setKeyboardHeight(null)
      }
    }

    if (typeof window?.visualViewport !== 'undefined') {
      listener()
      window.visualViewport.addEventListener('resize', listener)
    }

    return () => {
      if (typeof window?.visualViewport !== 'undefined') {
        window.visualViewport.removeEventListener('resize', listener)
      }
    }
  }, [isKeyboardOpen])

  return { isKeyboardOpen, keyboardHeight }
}

export default useMobileKeyboardOpen
